import tippy from 'tippy.js';

document.addEventListener('DOMContentLoaded', () => {
    tippy('[data-tippy-content]', {
        placement: 'bottom',
        arrow: true,
        animation: 'fade',
        allowHTML: true,
    });
});
